import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@certn/cascadia-react";
import { BasicButton, PrimaryButton, Modal, Text } from "@certn/cascadia";
import { useTranslation } from "react-i18next";

interface TabSwitchWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function TabSwitchWarningModal({
  isOpen,
  onClose,
  onConfirm,
}: TabSwitchWarningModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      testID="tab-switch-warning-modal"
      isOpen={isOpen}
      onOpenChange={onClose}
    >
      <Dialog>
        <DialogHeader onClose={onClose}>
          {t("Leave Quickscreen selection?")}
        </DialogHeader>
        <DialogContent>
          <Text>
            {t(
              "You’ve selected checks that are eligible for Quickscreen. Quickscreen orders must contain only Quickscreen-eligible checks. Switching back to the full list of checks, will remove your current selections."
            )}
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose} testID="cancel-tab-switch">
            {t("Go back")}
          </BasicButton>
          <PrimaryButton onPress={onConfirm} testID="confirm-tab-switch">
            {t("Clear selection")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
